export default __webpack_public_path__ + "static/1241-b7a96e7a9c84a430f04d6cb4c4d9e41e.gif";